import type { Map as MapType } from "maplibre-gl";
import type { MapEventBus } from "../core/MapEventBus";
import type { InteractionHandler } from "./types";
import { AircraftClickHandler } from "./AircraftClickHandler";
import { SilosClickHandler } from "./SilosClickHandler";
import { PdarsClickHandler } from "./PdarsClickHandler";

export class InteractionManager {
  private handlers: InteractionHandler[] = [];

  constructor(
    private map: MapType,
    private eventBus: MapEventBus,
  ) {
    this.registerHandlers();
  }

  private registerHandlers() {
    // Register all interaction handlers
    const aircraftHandlers: InteractionHandler[] = [new AircraftClickHandler()];
    const silosHandlers: InteractionHandler[] = [new SilosClickHandler()];
    const pdarsHandlers: InteractionHandler[] = [new PdarsClickHandler()];

    aircraftHandlers.forEach((handler) => {
      console.log(`[InteractionManager] Registering: ${handler.name}`);
      handler.initialize(this.map, this.eventBus);
      this.handlers.push(handler);
    });

    silosHandlers.forEach((handler) => {
      console.log(`[InteractionManager] Registering: ${handler.name}`);
      handler.initialize(this.map, this.eventBus);
      this.handlers.push(handler);
    });

    pdarsHandlers.forEach((handler) => {
      console.log(`[InteractionManager] Registering: ${handler.name}`);
      handler.initialize(this.map, this.eventBus);
      this.handlers.push(handler);
    });
  }
}
